require("../app-name-label/app-name-label");

module.exports = angular.module(__filename, []).directive("appTopBar", [function () {
    return {
        restrict: "E",
        template: require("./app-top-bar.html"),  
        transclude: true
    }
}]);
